module.exports = __webpack_public_path__ + "img/cases-part1-6.582005fd.png";